// import { DirectionalHint } from "@fluentui/react";
import { TooltipDelay } from "@fluentui/react/lib/Tooltip";

export const TooltipOpenDelay = TooltipDelay.long;
export const TooltipCloseDelay = 1000;
export const TooltipDirection = 1; // DirectionalHint.topCenter;
